export const segmentsOf = (path: string) => {
  const endIndex = decodeURIComponent(path).indexOf('?');
  const pathSliced = endIndex === -1 ? path : path.slice(0, endIndex);
  return pathSliced.split('/');
};
